/* unplugin-vue-components disabled */import { render } from "./w-scrollbar.vue?vue&type=template&id=198d2ed4&ts=true"
import script from "./w-scrollbar.vue?vue&type=script&lang=ts"
export * from "./w-scrollbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__